<template>
  <Flex center v-bind="$attrs" class="cursor-pointer min-w-10 h-10 px-2">
    <i v-if="icon" :class="icon"></i>
    <slot></slot>
  </Flex>
</template>

<script setup>
defineProps({
  icon: String,
})
</script>
